import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';

class WtPopoverSvgController implements angular.IController {
    placement: string;
    popoverClass: string;
    template: string;

    static $inject = [];
}

export const WtPopoverSvgDirective: DirectiveDefinition = {
    directiveId: 'wtPopoverSvg',
    template: require('./popoverSvg.directive.html'),
    restrict: 'A',
    scope: {
        item: '<',
        placement: '@?',
        popoverClass: '@?',
        template: '@'
    },
    controller: WtPopoverSvgController,
    bindToController: true,
    controllerAs: 'vm',
    templateNamespace: 'svg',
    transclude: true
};